<template>
	<v-card :elevation="elevation" height="100%" class="d-flex flex-column">
		<v-app-bar :class="showAppBar ? 'color-white' : ''" tag="div" dense flat :color="showAppBar ? 'primary' : 'white'" class="shrink">
			<v-app-bar-title> {{ title }} </v-app-bar-title>
			<v-spacer />
			<slot name="header-btn" />
		</v-app-bar>
		<v-sheet elevation="0" :height="height" :class="`pa-2 overflow-y-auto grow${height ? '' : ' chart-wrapper'}`">
			<Bar v-if="chartType == 'bar'" class="fill-height" :chart-options="chartOptions" :chart-data="chartData" :height="height - 16" />
			<Pie v-else-if="chartType == 'pie'" class="fill-height" :chart-options="chartOptions" :chart-data="chartData" :height="height - 16" />
			<Radar v-else-if="chartType == 'radar'" class="fill-height" :chart-options="chartOptions" :chart-data="chartData" :height="height - 16" />
			<Doughnut v-else-if="chartType == 'doughnut'" class="fill-height" :chart-options="chartOptions" :chart-data="chartData" :height="height - 16" />
			<PolarArea v-else-if="chartType == 'polar'" class="fill-height" :chart-options="chartOptions" :chart-data="chartData" :height="height - 16" />
			<Bubble v-else-if="chartType == 'bubble'" class="fill-height" :chart-options="chartOptions" :chart-data="chartData" :height="height - 16" />
			<LineChart v-else-if="chartType == 'line'" class="fill-height" :chart-options="chartOptions" :chart-data="chartData" :height="height - 16" />
		</v-sheet>
	</v-card>
</template>

<script>
import { Doughnut, Bar, Pie, Radar, PolarArea, Bubble, Line as LineChart } from "vue-chartjs/legacy"
import {
	Chart as ChartJS,
	Title,
	Tooltip,
	Legend,
	BarElement,
	CategoryScale,
	LinearScale,
	RadialLinearScale,
	ArcElement,
	PointElement,
	LineElement,
} from "chart.js"
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement, RadialLinearScale, PointElement, LineElement)
export default {
	props: {
		title: { type: String, required: false, default: null },
		chartType: {
			type: String,
			required: true,
			validator: (value) => {
				return ["bar", "pie", "radar", "doughnut", "polar", "bubble", "line"].indexOf(value) !== -1
			},
		},
		chartData: {
			type: Object,
			required: true,
		},
		chartOptions: {
			type: Object,
			required: false,
			default: () => ({ responsive: true, maintainAspectRatio: false }),
		},
		height: {
			type: Number,
			required: false,
			default: 200,
		},
		showAppBar: {
			type: Boolean,
			default: true,
			required: false,
		},
		elevation: {
			type: Number,
			default: 5,
			required: false,
		},
	},
	components: {
		Bar,
		Pie,
		Doughnut,
		Radar,
		PolarArea,
		Bubble,
		LineChart,
	},
	data() {
		return {}
	},
}
</script>

<style lang="scss" scoped>
.chart-wrapper {
	height: calc(100% - 48px);
}
</style>
